"use client";

import { ThemeProvider as NextThemesProvider, useTheme } from "next-themes";
import type React from "react";
import { useEffect } from "react";

function ThemeStylesApplier() {
  const { theme, resolvedTheme, setTheme } = useTheme();

  useEffect(() => {
    const root = document.documentElement;

    // Migrate legacy stored value "black" to dark
    if (theme === "black") {
      setTheme("dark");
    }

    // Clean up any old true-black flags
    try {
      if (typeof window !== "undefined") {
        window.localStorage?.removeItem("org-true-black");
      }
    } catch {}

    // Apply theme classes
    if (theme === "arcade") {
      root.classList.add("arcade");
      root.style.setProperty("color-scheme", "dark");
    } else {
      root.classList.remove("arcade");
      root.classList.remove("true-black");
      root.style.setProperty("color-scheme", resolvedTheme || "light");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme, resolvedTheme]);

  return null;
}

export function OrgThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="dark"
      enableSystem
      disableTransitionOnChange
      storageKey="org-theme"
      themes={["light", "dark", "arcade"]}
    >
      <ThemeStylesApplier />
      {children}
    </NextThemesProvider>
  );
}
